import { render, staticRenderFns } from "./GChatDrawerMenuBrand.vue?vue&type=template&id=5fd507bd&scoped=true&"
import script from "./GChatDrawerMenuBrand.vue?vue&type=script&lang=ts&"
export * from "./GChatDrawerMenuBrand.vue?vue&type=script&lang=ts&"
import style0 from "./GChatDrawerMenuBrand.vue?vue&type=style&index=0&id=5fd507bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd507bd",
  null
  
)

export default component.exports